// extracted by mini-css-extract-plugin
export default {"tbodyHigh":"SponsorsPageView_tbodyHigh_Qh4Vz"};